/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumPfeilRechts: {
    name: 'big-medium-pfeil-rechts';
    data: string;
} = {
    name: 'big-medium-pfeil-rechts',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M124.16 66.77a4 4 0 0 0 .22-.4c.08-.15.17-.3.24-.46a5 5 0 0 0 .16-.53c0-.13.09-.26.12-.4a5 5 0 0 0 0-2c0-.14-.08-.27-.12-.4a5 5 0 0 0-.16-.53c-.07-.16-.16-.31-.24-.46a4 4 0 0 0-.22-.4 6 6 0 0 0-.53-.66l-.09-.1L69.24 6a5 5 0 0 0-7.09 7L108 59H8a5 5 0 0 0 0 10h100l-45.85 46a5 5 0 0 0 7.09 7l54.3-54.5.09-.1a6 6 0 0 0 .53-.63"/></svg>`,
};
